/** One spread's visual references share one limit, regardless of their category. */
export const SCENE_REFERENCE_LIMIT = 10;
export function sceneReferenceCount(scene) {
    return (new Set(scene.characterIds).size + new Set(scene.thingIds).size + (scene.locationId ? 1 : 0));
}
/** Shared technical instruction for the story writer and the visual continuity editor. */
export const SCENE_REFERENCE_INSTRUCTION = `Each spread may use at most ${SCENE_REFERENCE_LIMIT} visual references TOTAL: ` +
    'characterIds plus thingIds plus one reference when locationId is not null. ' +
    'Plan the visible cast, props and setting to fit this combined limit. ' +
    'Distribute subjects across spreads when necessary; do not depict a catalog subject while omitting its required reference ID.';
//# sourceMappingURL=scene-references.js.map